export default __webpack_public_path__ + "static/media/4278164_Can_Yetismis.3e281043.pdf";